import { useEffect, useState } from "react"
import { makeStyles } from '@material-ui/core/styles';
import { Box, Grid } from '@material-ui/core';
import clsx from 'clsx';
import { CREATOR_COMPARE_TABLE_HEADER } from '../../../../../config/mock';
import { CompareTableBody } from "../../../../atoms/tables/compareTableBody";
import { CompareTableHeader } from "../../../../atoms/tables/compareTableHeader";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import { useStylesTooltip } from "../../../../../config/theme";
import UtilService from "../../../../../helper/service";
import _ from "underscore";
import useWindowSize from "../../../../../helper/hooks/useWindowSize";
import { getTagWiseData } from "../../../../../store/actions/creator/compare";
import { useDispatch, useSelector } from "react-redux";

const useStyles = makeStyles(() => ({
  tr: {
    height: 65,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontFamily: 'roboto-regular',
    color: '#697683',
    fontSize: 14,
    borderBottom: '1px solid #F5F5F5',
    '& div': {
      textAlign: 'center'
    },
  },
  opened: {
    marginTop: '22px!important',
  },
  row: {
    background: '#fff',
  },
  bg: {
    background: '#F2F7FC!important',
  },
  borderRadius10: {
    borderRadius: 10,
    boxShadow: '0px 0px 4px #00000033',
  },
  borderRadiusBottom: {
    borderRadius: '0px 0px 10px 10px'
  },
  card: {
    boxShadow: '0px 0px 4px #00000033',
    borderRadius: 10
  },
  img: {
    width: 83,
    height: 52,
    borderRadius: 10,
    marginRight: 25
  },
  icon: {
    borderRadius: 3,
    width: 18,
    height: 18,
    backgroundColor: '#f5f8fa',
    backgroundImage: "url(\"/assets/icons/dashboard/uncheckbox.svg\")",
  },
  checkedIcon: {
    '&:before': {
      display: 'block',
      width: 21,
      height: 18,
      backgroundImage: "url(\"/assets/icons/dashboard/checkbox.svg\")",
      content: '""',
    },
  },
  healthyText: {
    color: '#46C690',
    fontFamily: 'roboto-bold',
    fontSize: 14
  },
  dangerText: {
    color: '#EB6D9D',
    fontFamily: 'roboto-regular',
    fontSize: 14
  },
  left: {
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center'
  },

}));

function CompareTable(props: any) {

  const classes = useStyles();
  const [open, setOpen] = useState<number>(-1);
  const { experienceList, currentFilterArray, setTagLoading, compareTabData = [] } = props; //projectId is missing here
  const { is_loading, listLoading } = useSelector((state: any) => state.experience);
  const { sortImmersion } = useSelector((state: any) => state.compare);
  const [realSessions, setRealSessions] = useState([]);
  const [averageSessions, setAverageSessions] = useState<any>([]);
  const { width } = useWindowSize();
  const dispatch = useDispatch();
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const [wiseAllTags, setWiseAllTags] = useState<any>([]);
  const { cliped: mainClip } = useSelector((state: any) => state.analysis);

  const defaultImmersionTags = ['captivated', 'absorbed', 'interested', 'indifferent', 'tuned-out'];
  const defaultSafetyTags = ['zen', 'very-safe', 'safe', 'unsafe', 'very-unsafe'];

  const wiseTagIMM = wiseAllTags.reduce(function (filtered: any, item: any) {
    filtered.push(...item.tag_wise_immersion.map((x: any) => x.tag_name?.toLowerCase()))
    return _.uniq(filtered)
  }, [])

  const wiseTagImmersions = wiseTagIMM[0] === 'captivated' ? defaultImmersionTags : wiseTagIMM

  const wiseTagSAF = wiseAllTags.reduce(function (filtered: any, item: any) {
    filtered.push(...item.tag_wise_safety.map((x: any) => x.tag_name?.toLowerCase()))
    return _.uniq(filtered)
  }, [])

  const wiseTagSafetys = wiseTagSAF[0] === 'zen' ? defaultSafetyTags : wiseTagSAF;

  useEffect(() => {
    if (!listLoading && !is_loading) {
      onGetFullTagsData();
    }
  }, [listLoading, is_loading, mainClip, compareTabData])

  useEffect(() => {
    if (experienceList.length > 0) {
      const filterSessions = experienceList.filter((item: any) => item.session_code !== 'industry_norm');
      const sessions = filterSessions.map((item: any) => {
        const { session_length, session_type } = item;
        if (UtilService.isShowSafety(session_type, Number(session_length))) {
          return { ...item };
        } else {
          return { ...item, safety: 0 }
        }
      });
      setRealSessions(sessions);
    }
  }, [experienceList]);

  const tagsAddional = ['my_average', 'my_benchmark', 'industry_average']
  const compareFilter = UtilService.compareText2(currentFilterArray.compareFilter);
  const isTagAvailable = wiseAllTags?.find((x: any) => !tagsAddional.includes(x.session_code))

  useEffect(() => {
    if (realSessions.length > 0) {
      const myAvg = compareTabData?.find((x: any) => x.session_code === 'my_average')
      const myBen = compareTabData?.find((x: any) => x.session_code === "my_benchmark")
      const myInd = compareTabData?.find((x: any) => x.session_code === "industry_average")

      const tagedExperienceList: any = isTagAvailable ? experienceList.filter((x: any) => x.name_code !== "industry_average").map((t: any) => {
        const mySession = wiseAllTags.find((p: any) => p.session_code === t.session_code)
        return {
          ...t,
          immersion_detail: mySession ? UtilService.getTagCompare(mySession, 'immersion') : {},
          safety_detail: mySession ? UtilService.getTagCompare(mySession, 'safety') : {}
        }
      }) : experienceList

      const industryAverage = {
        session_id: 999999,
        project_id: null,
        session_code: "industry_norm",
        session_title: "Industry Average",
        name: "Industry Average",
        session_description: "",
        name_code: 'industry_average',
        immersion: myInd?.immersion,
        safety: myInd?.safety,
        immersion_detail: myInd ? UtilService.getTagCompare(myInd, 'immersion') : {},
        safety_detail: myInd ? UtilService.getTagCompare(myInd, 'safety') : {},
      }

      const myAverage = {
        session_id: 199999,
        project_id: null,
        session_code: "industry_norm",
        session_title: "My Average",
        name: "My Average",
        name_code: 'my_average',
        session_description: "",
        immersion: myAvg?.immersion,
        safety: myAvg?.safety,
        immersion_detail: myAvg ? UtilService.getTagCompare(myAvg, 'immersion') : {},
        safety_detail: myAvg ? UtilService.getTagCompare(myAvg, 'safety') : {},
      }

      const myBenchmark = {
        session_id: 199998,
        project_id: null,
        session_code: "industry_norm",
        name_code: 'my_benchmark',
        session_title: "My Benchmark",
        name: "My Benchmark",
        session_description: "",
        immersion: myBen?.immersion,
        safety: myBen?.safety,
        immersion_detail: myBen ? UtilService.getTagCompare(myBen, 'immersion') : {},
        safety_detail: myBen ? UtilService.getTagCompare(myBen, 'safety') : {},
      }

      const myAverageSessions = myBen
        ? [...tagedExperienceList, industryAverage, myAverage, myBenchmark]
        : [...tagedExperienceList, industryAverage, myAverage];

      const filterData: any = myAverageSessions.sort((a, b): any => {
        if (compareFilter === 'immersion' || compareFilter === 'safety') {
          return (b[compareFilter] || 0) - (a[compareFilter] || 0);
        } else {
          if (sortImmersion) {
            return (b.immersion_detail[compareFilter] || 0) - (a.immersion_detail[compareFilter] || 0);
          }
          else {
            return (b.safety_detail[compareFilter] || 0) - (a.safety_detail[compareFilter] || 0);
          }
        }
      })

      setAverageSessions(currentFilterArray.filterDirection ? [...filterData] : [...filterData.reverse()]);

    }
  }, [realSessions, experienceList, wiseAllTags, compareTabData, currentFilterArray]);

  const onGetFullTagsData = async () => {
    setTagLoading(true)
    const resArray = await Promise.all(experienceList.map(async (item: any) => {

      if (item.session_code === 'industry_norm') return null

      const isSelectedSessionClip = mainClip?.clip_id && (item.session_id + '')?.includes(mainClip?.clip_id);
      const isMod = typeof mainClip?.start_clip === 'number' && mainClip?.start_clip > 1000000

      const request = isSelectedSessionClip ? {
        clip_id: mainClip.clip_id,
        session_code: mainClip.session_code,
        from_clip: isMod ? mainClip?.start_clip + '' : UtilService.overviewHighlightsTimeFormat(mainClip?.start_clip),
        to_clip: isMod ? mainClip?.end_clip + '' : UtilService.overviewHighlightsTimeFormat(mainClip?.end_clip),
      } : (item?.clip_id ? {
        clip_id: item.clip_id,
        session_code: item.session_code,
        from_clip: item?.start + '',
        to_clip: item?.end + '',
      } : { session_code: item.session_code });

      const result = await new Promise((resolve) => {
        dispatch(getTagWiseData(apolloClient.client, request, (res: any) => {
          if (res) {
            resolve({ ...res, session_code: item.session_code })
            // resolve({ ...res, session_code: item.session_code + (item.clip_id || item.session_id), })
          } else {
            resolve(null)
          }
        }));
      });
      return result;
    }))

    const my = compareTabData?.length > 0 ? [...resArray, ...compareTabData] : resArray;
    setWiseAllTags([...my.filter(i => !!i)])
    setTagLoading(false)
  }

  // console.log('compareTabData: ', compareTabData)
  // console.log('experienceList: ', experienceList)
  // console.log('averageSessions: ', averageSessions)

  const isSafety = averageSessions.find((item: any) => item.safety > 1 && item.session_id !== 999999)
  const showSafety = isSafety ? true : false;

  const customTagsHeader = wiseTagImmersions.length > 0 ? [
    { title: "", width: 35, category: 'blank' },
    { title: "name", width: "100%", category: 'name' },
    { title: "immersion", width: 110, mobileWidth: 80, category: '' },
    ...wiseTagImmersions?.map((item: any) => {
      return {
        title: item, width: 110, mobileWidth: 80, category: 'immersion'
      }
    }),
    { title: "", width: 3, category: 'separator' },
    { title: "safety", width: 110, mobileWidth: 80, category: '' },
    ...wiseTagSafetys?.map((item: any) => {
      return {
        title: item, width: 110, mobileWidth: 80, category: 'safety'
      }
    })
  ] : [
    { title: "", width: 35, category: 'blank' },
    { title: "name", width: "100%", category: 'name' },
    { title: "immersion", width: 110, mobileWidth: 80, category: '' },
    { title: "", width: 3, category: 'separator' },
    { title: "safety", width: 110, mobileWidth: 80, category: '' },
  ];

  // const tagsOverallIndexSum = wiseAllTags.reduce((s: any, f: any) => s + f.tag_wise_immersion.reduce((x: any, k: any) => x + (Number(k.overall_index) || 0), 0), 0);
  // const isAvailableTagsDisplay = tagsOverallIndexSum > 0;

  const wiseTagsCount = wiseTagImmersions?.length;
  const customWidth = width - (width > 1025 ? 160 : width > 960 ? 90 : 30);
  const tableWidth = (wiseTagsCount > 10 && isTagAvailable) ? 110 * wiseTagsCount + 600 : customWidth - 2;

  const TableExperience = () => {

    return (
      <div className={clsx(open === -1 && classes.card)} style={{ overflow: 'auto', width: customWidth }}>

        <div style={{ width: tableWidth }}>
          <CompareTableHeader
            {...props}
            data={(wiseTagImmersions.length > 0 && isTagAvailable) ? customTagsHeader : CREATOR_COMPARE_TABLE_HEADER}
            showSafety={showSafety}
          />
          <TableContent
            {...props}
            open={open}
            setOpen={setOpen}
            sessions={averageSessions}
            showSafety={showSafety}
            wiseHeader={isTagAvailable ? customTagsHeader : CREATOR_COMPARE_TABLE_HEADER}
          />
        </div>
      </div>
    )
  }

  return (
    <div>
      {averageSessions?.length > 0 && <TableExperience />}
      {!averageSessions &&
        <Grid container alignItems={'center'} justifyContent={'center'}>
          <Box m={3}>No experience!</Box>
        </Grid>
      }
    </div>
  )
}

export default CompareTable;

function TableContent(props: any) {

  const classes = useStyles();
  const tooltipClasses = useStylesTooltip();
  const { sessions, open, showSafety, wiseHeader, } = props;
  const [initialHover, setInitialHover] = useState<any>('');

  const onShowSafety = (item: any) => {
    const { session_type, session_length } = item;
    return UtilService.isShowSafety(session_type, Number(session_length));
  };

  return (
    <div>
      {
        sessions.map((item: any, index: number) =>
          item?.session_code === 'industry_norm' ? (
            <Tooltip key={index} classes={tooltipClasses} title="Average for this type of Experience" placement="bottom" arrow>
              <div
                key={index}
                className={clsx(
                  classes.row,
                  item && ('session_id' in item) && item.session_id === open && classes.borderRadius10,
                  index === sessions.length - 1 && classes.borderRadiusBottom,
                  (item && ('session_id' in item) && initialHover === item.session_id && open !== item.session_id) && classes.bg
                )}
                onMouseOver={() => setInitialHover(item.session_id)}
                onMouseLeave={() => setInitialHover('')}
              >
                {item &&
                  <CompareTableBody
                    HEADER={CREATOR_COMPARE_TABLE_HEADER}
                    wiseHeader={wiseHeader}
                    showSafety={showSafety}
                    item={item}
                    initialHover={initialHover}
                    final={sessions.length === index + 1}
                    {...props}
                  />}
              </div>
            </Tooltip>
          ) : (
            <div
              key={index}
              className={clsx(
                classes.row,
                item && ('session_id' in item) && item.session_id === open && classes.borderRadius10,
                index === sessions.length - 1 && classes.borderRadiusBottom,
                (item && ('session_id' in item) && initialHover === item.session_id && open !== item.session_id) && classes.bg
              )}
              onMouseOver={() => setInitialHover(item.session_id)}
              onMouseLeave={() => setInitialHover('')}
            >
              {item &&
                <CompareTableBody
                  HEADER={CREATOR_COMPARE_TABLE_HEADER}
                  wiseHeader={wiseHeader}
                  showSafety={showSafety}
                  // item={onShowSafety(item) ? { ...item } : { ...item, safety: '0' }}
                  item={onShowSafety(item) ? { ...item } : { ...item }}
                  initialHover={initialHover}
                  final={sessions.length === index + 1}
                  {...props}
                />}
            </div>
          )
        )
      }
    </div>
  )
}